export async function float32ArrayToAudioBuffer(
  float32Array,
  sampleRate
) {
  const audioContext = new (window.AudioContext || window.webkitAudioContext)({
    sampleRate: sampleRate,
  });

  const audioBuffer = audioContext.createBuffer(
    1,
    float32Array.length,
    sampleRate
  );
  audioBuffer.getChannelData(0).set(float32Array);
  return audioBuffer;
}

export function audioBufferToWav(audioBuffer) {
  const numOfChannels = audioBuffer.numberOfChannels;
  const length = audioBuffer.length * numOfChannels * 2 + 44;
  const buffer = new ArrayBuffer(length);
  const view = new DataView(buffer);
  const channels = [];

  // Gather channel data from the AudioBuffer
  for (let i = 0; i < numOfChannels; i++) {
    channels.push(audioBuffer.getChannelData(i));
  }

  let offset = 0;
  const writeString = (str) => {
    for (let i = 0; i < str.length; i++) {
      view.setUint8(offset + i, str.charCodeAt(i));
    }
  };

  // Write WAV header
  writeString("RIFF");
  offset += 4;
  view.setUint32(offset, length - 8, true);
  offset += 4;
  writeString("WAVE");
  offset += 4;
  writeString("fmt ");
  offset += 4;
  view.setUint32(offset, 16, true); // PCM chunk size
  offset += 4;
  view.setUint16(offset, 1, true); // PCM format
  offset += 2;
  view.setUint16(offset, numOfChannels, true);
  offset += 2;
  view.setUint32(offset, audioBuffer.sampleRate, true);
  offset += 4;
  view.setUint32(offset, audioBuffer.sampleRate * numOfChannels * 2, true);
  offset += 4;
  view.setUint16(offset, numOfChannels * 2, true);
  offset += 2;
  view.setUint16(offset, 16, true);
  offset += 2;
  writeString("data");
  offset += 4;
  view.setUint32(offset, length - offset - 4, true);
  offset += 4;

  // Write interleaved audio samples
  for (let i = 0; i < audioBuffer.length; i++) {
    for (let j = 0; j < numOfChannels; j++) {
      const sample = Math.max(-1, Math.min(1, channels[j][i]));
      // Scale sample to 16-bit PCM
      view.setInt16(
        offset,
        sample < 0 ? sample * 0x8000 : sample * 0x7fff,
        true
      );
      offset += 2;
    }
  }

  return new Blob([buffer], { type: "audio/wav" });
}

export const convertBlobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const result = reader.result;
      const base64String = result;
      resolve(base64String);
    };
    reader.onerror = reject;
  });
};


export async function mergeBase64Audios(
  audioDataArray,
  sampleRate = 44100
) {
  const AudioContextConstructor =
    window.AudioContext || (window).webkitAudioContext;
  const audioContext = new AudioContextConstructor({
    sampleRate,
  });

  const audioBuffers = [];

  for (const { base64, interval } of audioDataArray) {
    try {
      const parts = base64.split(',');
      const base64String = parts.length > 1 ? parts[1] : parts[0];
      const audioData = atob(base64String);

      const audioArray = new Uint8Array(audioData.length);
      for (let i = 0; i < audioData.length; i++) {
        audioArray[i] = audioData.charCodeAt(i);
      }

      const buffer = await audioContext.decodeAudioData(
        audioArray.buffer
      );
      audioBuffers.push({ buffer, interval });
    } catch (error) {
      console.error(
        'Failed to decode audio chunk. Skipping to next chunk.',
        error
      );
      continue; // Move to the next chunk without stopping execution
    }
  }

  if (audioBuffers.length === 0) {
    throw new Error('No valid audio buffers to merge.');
  }

  let totalSamples = 0;
  audioBuffers.forEach(({ buffer, interval }) => {
    totalSamples += buffer.length + interval * sampleRate;
  });

  const outputBuffer = audioContext.createBuffer(1, totalSamples, sampleRate);
  const outputData = outputBuffer.getChannelData(0);

  let offset = 0;
  for (const { buffer, interval } of audioBuffers) {
    const inputData = buffer.getChannelData(0);
    if (offset + inputData.length > outputData.length) {
      console.error('Audio chunk exceeds allocated buffer size.');
      break;
    }
    outputData.set(inputData, offset);
    offset += inputData.length + interval * sampleRate;
  }

  return outputBuffer;
}

// export async function saveAudio(
//   audioBuffer,
//   callId
// ) {
//   try {
//     const wavBlob = audioBufferToWav(audioBuffer);
//     URL.createObjectURL(wavBlob);
//     const formData = new FormData();
//     formData.append('file', wavBlob, 'recording.wav');
//     formData.append('call_id', callId);
//     await uploadCallRecording(formData);
//   } catch (e) {
//     console.log(e);
//   }
// }


export async function saveAudio(audioBuffer, callId) {
  try {
    const wavBlob = audioBufferToWav(audioBuffer);

    // Create a download link
    // const downloadUrl = URL.createObjectURL(wavBlob);
    // const a = document.createElement("a");
    // a.href = downloadUrl;
    // a.download = `recording_${callId}.wav`;
    // document.body.appendChild(a);
    // a.click();
    // document.body.removeChild(a);
    // URL.revokeObjectURL(downloadUrl);

    // Upload the recording
    const formData = new FormData();
    formData.append("file", wavBlob, "recording.wav");
    formData.append("call_id", callId);
    await uploadCallRecording(formData);
  } catch (e) {
    console.log(e);
  }
}


export const uploadCallRecording = async (payload) => {

  try {
    const response = await fetch(
      "https://indigenius.shop/call/upload-recording",
      {
        method: "POST",
        body: payload,
      }
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Upload failed:", error);
    throw error;
  }
};
